import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import {appTitle, NAV, PROFILENAV} from "./nav";
import {NavigationService} from "../../../../packages/fe/core/navigation.service";
import {Subscription} from "rxjs";
import {DeviceService, ScreenSize} from "../../../../packages/fe/core/device.service";
import {environment} from "../environments/environment";
import {UserService} from "../../../../packages/fe/core/user.service";
import {PwaService} from "../../../../packages/fe/core/pwa.service";
import {RouterLink, RouterOutlet} from '@angular/router';
import {Menubar} from "primeng/menubar";
import {NgClass} from "@angular/common";
import {Avatar} from "primeng/avatar";
import {Ripple} from "primeng/ripple";
import {User} from "../../../../packages/fe/core/_datamodel/user";
import {Button} from "primeng/button";
import {Menu} from "primeng/menu";
import {Toast} from "primeng/toast";
import {Drawer} from 'primeng/drawer';
import {ConfirmDialog} from "primeng/confirmdialog";
import {FormsModule} from "@angular/forms";
import {
  PANELMENU,
  MENUBAR,
  BUTTON_NAV,
  HAMBURGER_BTN,
  MENUBAR_MOBILE,
  BUTTON_NAV_MOBILE,
  AVATAR_MOBILE
} from "../theme-preset";
import {Tooltip} from "primeng/tooltip";
import {PanelMenu} from "primeng/panelmenu";
import {MenuItem, MessageService} from "primeng/api";
import {LoginComponent} from "./login/login.component";
import {CosoChatComponent} from "../../../../packages/fe/features/coso/coso/coso-chat/coso-chat.component";
import {NotificationsService} from "../../../../packages/fe/core/notifications.service";
import {Tag} from "primeng/tag";
import {CosoService} from "../../../../packages/fe/features/coso/coso/coso.service";
import {CosoConfig} from "../../../../packages/fe/features/coso/coso-config/datamodel";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, Menubar, NgClass, Avatar, Ripple, Button, RouterLink, Menu, Toast, ConfirmDialog, Drawer, FormsModule, Tooltip, PanelMenu, LoginComponent, CosoChatComponent, Tag]
})
export class AppComponent implements OnInit, OnDestroy {
  // Nav
  protected readonly appTitle = appTitle;
  protected readonly appVersion = environment.VERSION;
  protected test = environment.test;
  protected navItems = NAV;
  public logoutItem: MenuItem = {
    label: 'Logout',
    icon: 'pi pi-sign-out',
    command: () => {
      this.logout();
      this.cdr.markForCheck();
    }
  }
  public lightMenuItem: MenuItem = {
    label: 'Light Mode',
    icon: 'pi pi-sun',
    command: () => {
      this.switchTheme();
      this.cdr.markForCheck();
    }
  }
  public darkMenuItem: MenuItem = {
    label: 'Dark Mode',
    icon: 'pi pi-moon',
    command: () => {
      this.switchTheme();
      this.cdr.markForCheck();
    }
  }
  public notificationOffItem: MenuItem = {
    label: 'Enable Notifications',
    icon: 'pi pi-bell-slash',
    command: () => {
      this.notificationService.enableNotifications();
      this.cdr.markForCheck();
    }
  }
  public notificationOnItem: MenuItem = {
    label: 'Disable Notifications',
    icon: 'pi pi-bell',
    command: () => {
      this.notificationService.disableNotifications();
      this.cdr.markForCheck();
    }
  }
  public layout: string = 'horizontal';
  public sidebar = 'expanded';
  public darkMode = false;
  private $navSub: Subscription | undefined;
  private $screenSize: Subscription | undefined;
  public screenSize: ScreenSize = {
    width: window.innerWidth,
    height:innerHeight
  }
  public networkMode: boolean = true;
  public user: User | null | undefined;
  private $userSub: Subscription | undefined;
  private $allowedCosoConfigsSub: Subscription | undefined;
  public loading = true;

  // Styling
  public PANELMENU = PANELMENU;
  public MENUBAR = MENUBAR;
  public BUTTON_NAV = BUTTON_NAV;
  public HAMBURGER_BTN = HAMBURGER_BTN;

  // Coso
  public cosoDrawerFullScreen = false;
  public chatBotDrawer: boolean = false;
  public allowedCosoConfigs: CosoConfig[] = [];

  constructor(public navigationService: NavigationService,
              public deviceService: DeviceService,
              public notificationService: NotificationsService,
              private userService: UserService,
              private cosoService: CosoService,
              private pwa: PwaService,
              private cdr: ChangeDetectorRef) {
    this.layout = localStorage.getItem('settings.nav.orientation') || 'vertical';
    this.sidebar = localStorage.getItem('settings.nav.sidebar') || 'expanded';
  }

  ngOnInit() {
    // Current user
    this.$userSub = this.userService.$user.subscribe(user => {
      // null: logged out, undefined: loading
      this.user = user;
      // If the group is disabled logout
      if(this.userService.isSignedIn() && this.user?.group_enabled !== 1) {
        alert(`Group ${this.user?.group_name} is disabled.`)
        // can't use this beacause when signin out the page is completely reloaded: this.messageService.add({severity: 'error', summary: 'Error', detail: `Group ${this.user?.group_name} is disabled`, sticky: true});
        this.userService.logout();
      }
      // If the user is disabled logout
      if(this.userService.isSignedIn() && this.user?.enabled !== 1) {
        alert(`This user is disabled.`)
        // can't use this beacause when signin out the page is completely reloaded: this.messageService.add({severity: 'error', summary: 'Error', detail: `This user is disabled`, sticky: true});
        this.userService.logout();
      }
      // Set navigation
      if(user?.privileges.nav) {
        if(environment.test) console.debug('Setting navigation items from group');
        this.navItems = user.privileges.nav;
      }
      if(this.user !== undefined) {
        this.loading = false;
      }
      this.cdr.markForCheck();
    })
    this.$allowedCosoConfigsSub = this.cosoService.allowedCosoConfigs$.subscribe(configs => {
      this.allowedCosoConfigs = configs ?? [];
      this.cdr.markForCheck();
    });
    // Screen size change logic (applies also to orientation change!)
    this.$screenSize = this.deviceService.$screenSize.subscribe((screenSize: ScreenSize) => {
        this.screenSize = screenSize;
      if(!environment.production) { console.debug('Screen inner space:',this.screenSize.width,'x',this.screenSize.height); }
      // TODO: Insert your logic here!
      this.cdr.markForCheck();
    });
    // Subscribe to network status changes
    this.pwa.networkMonitor().subscribe(online => {
      this.networkMode = online;
      console.warn('Network status change:', online);
      // TODO: Insert your logic here!
      this.cdr.markForCheck();
    });
  }

  getProfileItems(): MenuItem[] {
    if(!this.deviceService.isMobile) {
      return PROFILENAV.concat([{separator: true },this.logoutItem]);
    } else {
      let menu = [...PROFILENAV,{separator: true }];
      if(this.navigationService.activeTheme === 'dark-theme') {
        menu = menu.concat([this.lightMenuItem]);
      } else {
        menu = menu.concat([this.darkMenuItem]);
      }
      if(this.notificationService.notificationStatus === 'granted') {
        menu = menu.concat([this.notificationOnItem,{separator: true },this.logoutItem]);
      } else {
        menu = menu.concat([this.notificationOffItem,{separator: true },this.logoutItem]);
      }
      return menu;
    }
  }

  ngOnDestroy() {
    this.$navSub?.unsubscribe();
    this.$screenSize?.unsubscribe();
    this.$userSub?.unsubscribe();
    this.$allowedCosoConfigsSub?.unsubscribe();
  }

  getAvatar(): string {
    // @ts-ignore
    //return this.user?.firstname[0].toUpperCase() || '';
    return (this.user?.firstname[0].toUpperCase()+this.user?.lastname[0].toUpperCase()) || '';
  }

  switchTheme() {
    this.navigationService.switchTheme();
    this.darkMode = !this.darkMode;
  }

  logout(): void {
    this.userService.logout();
  }

  switchLayout() {
    if(this.layout === 'horizontal') {
      this.layout = 'vertical';
    } else this.layout = 'horizontal';
    localStorage.setItem('settings.nav.orientation', this.layout)
    localStorage.setItem('settings.nav.sidebar', this.sidebar)
  }

  collapseSideBar(): void {
    if(this.sidebar === 'expanded') { this.sidebar = 'collapsed'; }
    else this.sidebar = 'expanded';
    localStorage.setItem('settings.nav.sidebar', this.sidebar)
  }

  onChatDrawerVisibleChange(visible: boolean): void {
    this.chatBotDrawer = visible;
    this.cdr.markForCheck();
  }

  canOpenCosoChat(): boolean {
    return !!this.user?.privileges?.isAdmin || this.allowedCosoConfigs.length > 0;
  }

  protected readonly environment = environment;
  protected readonly MENUBAR_MOBILE = MENUBAR_MOBILE;
  protected readonly BUTTON_NAV_MOBILE = BUTTON_NAV_MOBILE;
  protected readonly AVATAR_MOBILE = AVATAR_MOBILE;
}
